import { cva, VariantProps } from 'class-variance-authority'
import clsx from 'clsx'
import React, { HTMLAttributes } from 'react'

import Text, { textVariants } from '@/components-latest/primitives/Text'

import Styles from './Fieldset.module.scss'

const fieldsetVariants = cva(Styles.fieldset, {
  variants: {
    flexDirection: {
      row: Styles.inline
    }
  }
})

interface IFieldSetProps
  extends HTMLAttributes<HTMLFieldSetElement>,
    VariantProps<typeof fieldsetVariants>,
    Pick<VariantProps<typeof textVariants>, 'variant' | 'weight'> {
  label: string
}

const Fieldset: React.FC<IFieldSetProps> = React.forwardRef<
  HTMLFieldSetElement,
  IFieldSetProps
>(
  (
    { label, children, className, flexDirection, variant, weight, ...props },
    ref
  ) => {
    return (
      <fieldset
        ref={ref}
        className={clsx(fieldsetVariants({ flexDirection }), className)}
        {...props}>
        <Text variant={variant || 'nextSubtitle'} weight={weight || 'bold'}>
          {label}
        </Text>
        {children}
      </fieldset>
    )
  }
)
Fieldset.displayName = 'Fieldset'

export { fieldsetVariants }
export default Fieldset
